import service from '@/utils/server';

const modName='/bd/gateSentry/';

export const gateSentryLatestDetails = data => {
  return service({
    url: modName + 'gateSentryLatestDetails',
    method: 'post',
    data
  });
};

export const entranceSituationDetails = data => {
  return service({
    url: modName + 'entranceSituationDetails',
    method: 'post',
    data
  });
};

export const exportSituationDetails = data => {
  return service({
    url: modName + 'exportSituationDetails',
    method: 'post',
    data
  });
};

export const faceEventDetails = data => {
  return service({
    url: modName + 'faceEventDetails',
    method: 'post',
    data
  });
};

export const faceVehicleMatchDetails = data => {
  return service({
    url: modName + 'faceVehicleMatchDetails',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/bd/gateSentryLatest/api/index.js